export default "__VITE_ASSET__207f7dfc__"